import React from 'react';
import {
  bool,
  func,
  string,
} from 'prop-types';
import {dissoc} from 'ramda';
import styles from './RadioButton.css';
import classNames from 'classnames';

const RadioButton = (props) => {
  return (
    <label className={classNames(styles.container, props.className)} disabled={props.disabled}>
      <input type="radio" {...dissoc('className', props)}/>
      {props.label}
    </label>
  );
};

RadioButton.propTypes = {
  label: string,
  autoFocus: bool,
  checked: bool,
  className: string,
  defaultChecked: bool,
  disabled: bool,
  form: string,
  name: string,
  value: string,
  onChange: func,
};

export default RadioButton;
